import { Component, Input, OnInit } from '@angular/core';
import { ToasterService } from '@purespectrum1/ui/toaster-service';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { QUALIFICATION_CODES } from '../../shared/constants/qualification-code';
import { V2SurveysQualification } from '../../shared/interfaces/qualification.interface';
import { AuthService } from '../../shared/services/auth/auth.service';
import { BuyerApiService } from '../../shared/services/buyer-api/survey.service';
import { SupplierApiService } from '../../shared/services/supplier-api/supplier-api.service';
import { Constants } from '../constants/manage-audience.constants';

@Component({
  selector: 'ps-ui-manage-audience',
  templateUrl: './manage-audience.component.html',
  styleUrls: ['./manage-audience.component.css'],
})
export class ManageAudienceComponent implements OnInit {
  public audienceData: V2SurveysQualification[] = [];
  @Input() surveyId!: number | undefined;
  @Input() countryCode: string;
  readonly QUALIFICATION_CODES = QUALIFICATION_CODES;
  constructor(
    private _buyerApiService: BuyerApiService,
    private _supplierApiService: SupplierApiService,
    private _toastr: ToasterService,
    private _authService: AuthService
  ) {}

  ngOnInit(): void {
    this._getQualifications();
  }

  private _getQualifications() {
    if (this._authService.userType === 'supplier') {
      this._supplierApiService.getQualifications(this.surveyId).subscribe(
        (qualifications: V2SurveysQualification[]) => {
          this.audienceData = qualifications;
        },
        (err) => {
          this._toastr.error(err.error.msg);
        }
      );
    } else {
      this._buyerApiService.getQualifications(this.surveyId).subscribe(
        (qualifications: V2SurveysQualification[]) => {
          if (this._canShowExtraCoreQualifications()) {
            this.audienceData = qualifications;
            return;
          }

          this.audienceData = qualifications.filter(
            (qualification) =>
              qualification.qualification_code !==
              QUALIFICATION_CODES.RELATIONSHIP
          );
        },
        (err) => {
          this._toastr.error(err.error.msg);
        }
      );
    }
  }

  downloadCsv(data: any, surveyId: number | undefined) {
    const options = {
      headers: ['zipcodes'],
    };
    new ngxCsv(data, `zipcodes_${surveyId}`, options);
  }

  _canShowExtraCoreQualifications() {
    return (
      this.countryCode !== Constants.AUSTRALIA_SHORT_CODE ||
      this._authService.buyerConfig?.enableExtraCoreQualification
    );
  }
}
